export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14297.a5aa224f.jpg";